
import { Vue, Component } from 'vue-facing-decorator';
import ConfigureEmail from '../components/Invite/Emails/Configure/ConfigureEmail.vue';
import { Root } from '@/main';

@Component({
  components: {
    ConfigureEmail,
  },
})
export default class Invite extends Vue {
  private mounted(){
    Root.emit('set-active-component', 'invite');
  }

}
